/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_PortalInputs */

const en_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller Portal`)
};

const es_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal de vendedor`)
};

const fr_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portail Vendeur`)
};

const de_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäuferportal`)
};

const ja_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品者ポータル`)
};

const zh_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卖家门户`)
};

const ar_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة البائع`)
};

const id_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Penjual`)
};

const it_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portale Venditore`)
};

const ru_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портал продавца`)
};

const pt_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal do Vendedor`)
};

const ko_seller_portal = /** @type {(inputs: Seller_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자 포털`)
};

/**
* | output |
* | --- |
* | "Seller Portal" |
*
* @param {Seller_PortalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_portal = /** @type {((inputs?: Seller_PortalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_PortalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_portal(inputs)
	if (locale === "es") return es_seller_portal(inputs)
	if (locale === "fr") return fr_seller_portal(inputs)
	if (locale === "de") return de_seller_portal(inputs)
	if (locale === "ja") return ja_seller_portal(inputs)
	if (locale === "zh") return zh_seller_portal(inputs)
	if (locale === "ar") return ar_seller_portal(inputs)
	if (locale === "id") return id_seller_portal(inputs)
	if (locale === "it") return it_seller_portal(inputs)
	if (locale === "ru") return ru_seller_portal(inputs)
	if (locale === "pt") return pt_seller_portal(inputs)
	return ko_seller_portal(inputs)
});